var MediaService = /** @class */ (function () {
    function MediaService(api) {
        this.API = api;
    }
    MediaService.prototype.getFiles = function (scope) {
        var url = "/media/files/scope/".concat(scope);
        return this.API.get(url);
    };
    MediaService.prototype.getFile = function (fileId) {
        var url = "/media/files/".concat(fileId);
        return this.API.get(url);
    };
    MediaService.prototype.getFolders = function () {
        var url = '/media/folders';
        return this.API.get(url);
    };
    return MediaService;
}());
export { MediaService };
